/**
 * @file 引入了所有 register 的入口文件
 * @author weijiaxun <weijiaxun@baidu.com>
 */
import './register/baidubox';
import './register/haokan';
import './register/tieba';
import './register/bdminivideo';
import './register/kanduoduo';
import './register/bdmap';
import './register/netdisk';
import './register/askmybaby';
import './register/baiduinput';
import './register/baidutranslate';
import './register/yike';
import './register/bdyinbo';
import './register/lemon';
import './register/tomas';
import './register/yiju';
import nativeReference, { nativeRegister as nativeRegisterReference } from './index';
export default nativeReference;
export const nativeRegister = nativeRegisterReference;
//# sourceMappingURL=registedEntry.js.map